module.exports = __webpack_public_path__ + "static/media/HalisR-Bold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/HalisR-Bold.otf
// module id = 888
// module chunks = 0